<main class="d-flex align-items-center main-forget py-3 py-md-0">
  <div class="container">
    <div class="card">
      <div class="row no-gutters">
        <div class="col-md-12 left-wrapper-forget">
          <div class="card-body-forget">
            <div class="brand-wrapper">
              <div class="logo">
                <h3 class="logo-title-forget ff-2">Forgot or Change Password</h3>
                <i title="Close" (click)="onClick_Cancel()" style="float: right; margin-top: -30px; cursor: pointer;"
                  class="fa fa-times-circle logo-title-forget ff-2" aria-hidden="true"></i>
              </div>
            </div>
            <div class="login-container">
              <div class="login-tab-container">
                <form (ngSubmit)="onClick_Submit()" [formGroup]="forgetPasswordForm" autocomplete="off">
                  <div class="form-group">
                    <label for="username" class="login-label-forget">User Name</label>
                    <input matInput type="text" formControlName="username" name="username" id="username"
                      class="form-control" placeholder="" value="" (paste)="$event.preventDefault()"
                      (copy)="$event.preventDefault()" required>
                    <mat-error *ngIf="forgetPasswordForm.get('username').hasError('required')">
                      User name is required
                    </mat-error>
                  </div>
                  <div class="form-group">
                    <label for="EmailId" class="login-label-forget">Email Id</label>
                    <input matInput type="text" formControlName="EmailId" name="EmailId"
                      pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}" id="EmailId" class="form-control"
                      placeholder="" value="" (paste)="$event.preventDefault()" (copy)="$event.preventDefault()"
                      required>
                    <mat-error *ngIf="forgetPasswordForm.get('EmailId').hasError('required')">
                      Email Id is required
                    </mat-error>
                    <mat-error *ngIf="forgetPasswordForm.get('EmailId').hasError('minLength')">
                      Email Id is invalid
                    </mat-error>
                  </div>
                  <div class="form-group">
                    <label for="password" class="login-label-forget">New Password</label>
                    <input matInput type="password" formControlName="password" name="password" id="password"
                      class="form-control" placeholder="" #x value="" (paste)="$event.preventDefault()"
                      (copy)="$event.preventDefault()" required>
                    <span class="field-icon"
                      [className]="x.type == 'password' ? 'fa fa-eye-slash field-icon' : 'fa fa-eye field-icon'"
                      (mouseup)="x.type = 'password'" (mousedown)="x.type='text'"
                      (mouseleave)="x.type = 'password'"></span>
                    <mat-error *ngIf="forgetPasswordForm.get('password').hasError('required')">
                      Password is required
                    </mat-error>
                  </div>
                  <div class="form-group">
                    <label for="retypePassword" class="login-label-forget">Retype New Password</label>
                    <input matInput type="password" formControlName="retypePassword" name="retypePassword"
                      id="retypePassword" class="form-control" placeholder="" #y value=""
                      (paste)="$event.preventDefault()" (copy)="$event.preventDefault()" required>
                    <span class="field-icon"
                      [className]="y.type == 'password' ? 'fa fa-eye-slash field-icon' : 'fa fa-eye field-icon'"
                      (mouseup)="y.type = 'password'" (mousedown)="y.type='text'"
                      (mouseleave)="y.type = 'password'"></span>
                    <mat-error *ngIf="forgetPasswordForm.get('retypePassword').hasError('required')">
                      Retype password is required
                    </mat-error>
                    <mat-error
                      *ngIf="forgetPasswordForm.get('password').value != forgetPasswordForm.get('retypePassword').value && !forgetPasswordForm.get('retypePassword').hasError('required')">
                      Password Mismatch
                    </mat-error>
                  </div>
                  <div class="row eip-pt-10">
                    <div class="col-md-12">
                      <i class="fa fa-star" style="color:#fff;"></i>
                      <span class="mat-error-message">Password should be combination of minimum 8 characters including 1
                        uppercase letter, 1 special character and alphanumeric characters.</span>
                    </div>
                  </div>
                  <div class="row eip-mt-15 pswrd-btn">
                    <div class="col-12 d-flex justify-content-end">
                      <input class="btn btn-secondary" type="button" value="Cancel" (click)="onClick_Cancel()">
                      <input [disabled]="!forgetPasswordForm.valid || isButtonDisabled"
                        class="btn btn-secondary eip-ml-20" type="button" value="Submit" (click)="onClick_Submit()">
                      <br>
                      <span *ngIf="isButtonDisabled">please try again after {{ timer }} seconds</span>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>